<template>
  <el-dialog custom-class="create-plan-dialog" :title="dialogTitle" :visible.sync="dialogVisible" width="1650px"
    top="4vh" :close-on-click-modal="false" append-to-body @opened="renderBarcodes" @closed="resetForm">
    <!-- 方案名称 -->
    <div class="plan-base">
      <div class="plan-base-item">
        <span class="label">{{ $t('message.planName') }}：</span>
        <el-input v-model="form.name" maxlength="20" show-word-limit :placeholder="$t('message.pleaseEnterPlanName')" />
      </div>
      <div class="plan-base-item">
        <span class="label">{{ $t('message.defaultOrderUse') }}：</span>
        <el-checkbox v-model="form.is_default">{{ $t('message.enableThisPlan') }}</el-checkbox>
      </div>
    </div>

    <!-- 下单链接 -->
    <div class="plan-block">
      <div class="block-head">
        <div class="section-name">{{ $t('message.orderLink') }}</div>
        <el-button class="danger-button" size="mini" @click="addChild">{{ $t('message.addComboProduct') }}</el-button>
      </div>

      <div class="link-table">
        <div class="link-head">
          <div class="col-link">{{ $t('message.ProductLink') }}</div>
          <div class="col-info">{{ $t('message.commodityInformation') }}</div>
          <div class="col-attr">{{ $t('message.productAttributes') }}</div>
          <div class="col-price">{{ $t('message.purchasePrice') }}</div>
          <div class="col-num">{{ $t('message.quantity') }}</div>
          <div class="col-option">{{ $t('message.additionalServices') }}</div>
          <div class="col-remark">{{ $t('message.remark') }}</div>
        </div>

        <!-- 组套容器：主商品 + 最多 3 个同捆物 -->
        <div class="combo-group">
          <div class="link-row main-row">
            <div class="col-link">
              <div class="link-top">
                <span class="main-tag">{{ $t('message.mainProduct') }}</span>
                <el-button type="text" class="latest-link" @click="useLatestLink">{{ $t('message.useLatestOrderLink')
                }}</el-button>
              </div>
              <el-input type="textarea" :rows="3" v-model="form.link"
                :placeholder="$t('message.pleaseEnterTheProductLink')" @blur="fetchMainProduct" />
              <p class="link-tip">{{ $t('message.orderLinkSupportTip') }}</p>
            </div>
            <div class="col-info">
              <div class="product-info" v-if="form.pic || form.goods_title">
                <el-image v-if="form.pic" :src="form.pic" fit="cover" :preview-src-list="[form.pic]"
                  class="product-img" />
                <div class="product-text">
                  <el-tooltip :content="form.goods_title" placement="top" :disabled="!form.goods_title">
                    <p class="goods-title">{{ form.goods_title }}</p>
                  </el-tooltip>
                  <p>{{ $t('message.type') }}：{{ form.from_platform }}</p>
                </div>
              </div>
            </div>
            <div class="col-attr">
              <div class="attr-box" @click="editMainAttribute">
                <template v-if="form.detail.length">
                  <p v-for="(item, index) in form.detail" :key="index">
                    <span>{{ item.key }}</span>{{ item.value }}
                  </p>
                </template>
                <p v-else class="option-empty">{{ $t('message.clickToSelect') }}</p>
              </div>
            </div>
            <div class="col-price">
              <div class="price-text">¥{{ form.price }}</div>
            </div>
            <div class="col-num">
              <el-input v-model="form.num" />
            </div>
            <div class="col-option">
              <div class="option-box" @click="openOptionDialog">
                <p v-for="(item, index) in checkedOptions" :key="index">
                  {{ index + 1 }}{{ item.name }}*{{ item.num }}
                </p>
                <p v-if="!checkedOptions.length" class="option-empty">{{ $t('message.clickToSelect') }}</p>
              </div>
            </div>
            <div class="col-remark">
              <el-input type="textarea" v-model="form.client_remark" :rows="4"
                :placeholder="$t('message.customerRemarks')" />
            </div>
          </div>

          <div class="link-row child-row" v-for="(child, childIndex) in form.children" :key="'child-' + childIndex">
            <div class="col-link">
              <div class="link-top">
                <span class="child-tag">{{ $t('message.comboItem') }}{{ childIndex + 1 }}</span>
              </div>
              <el-input type="textarea" :rows="3" v-model="child.link"
                :placeholder="$t('message.pleaseEnterTheProductLink')" @blur="fetchChildProduct(childIndex)" />
            </div>
            <div class="col-info">
              <div class="product-info" v-if="child.pic || child.goods_title">
                <el-image v-if="child.pic" :src="child.pic" fit="cover" :preview-src-list="[child.pic]"
                  class="product-img" />
                <div class="product-text">
                  <el-tooltip :content="child.goods_title" placement="top" :disabled="!child.goods_title">
                    <p class="goods-title">{{ child.goods_title }}</p>
                  </el-tooltip>
                  <p>{{ $t('message.type') }}：{{ child.from_platform }}</p>
                </div>
              </div>
            </div>
            <div class="col-attr">
              <div class="attr-box" @click="editChildAttribute(childIndex)">
                <template v-if="child.detail && child.detail.length">
                  <p v-for="(item, index) in child.detail" :key="index">
                    <span>{{ item.key }}</span>{{ item.value }}
                  </p>
                </template>
                <p v-else class="option-empty">{{ $t('message.clickToSelect') }}</p>
              </div>
            </div>
            <div class="col-price">
              <div class="price-text">¥{{ child.price }}</div>
            </div>
            <div class="col-num">
              <el-input v-model="child.num" />
            </div>
            <div class="col-option">
              <div class="option-box" @click="openChildOptionDialog(childIndex)">
                <p v-for="(item, index) in child.option.filter(o => o.checked)" :key="index">
                  {{ index + 1 }}{{ item.name }}*{{ item.num }}
                </p>
                <p v-if="!child.option.filter(o => o.checked).length" class="option-empty">{{
                  $t('message.clickToSelect') }}</p>
              </div>
            </div>
            <div class="col-remark child-remark">
              <el-input type="textarea" v-model="child.client_remark" :rows="3"
                :placeholder="$t('message.customerRemarks')" />
              <el-button type="text" class="delete-text" @click="removeChild(childIndex)">{{ $t('message.delete')
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 标签信息 -->
    <div class="plan-block">
      <div class="block-head">
        <div class="section-name">{{ $t('message.tagInformation') }}</div>
        <div class="block-actions">
          <el-button class="warn-button" size="mini" @click="openHistoryTag">{{ $t('message.historyTag') }}</el-button>
          <el-button class="success-button" size="mini" @click="addTag">{{ $t('message.addNewTag') }}</el-button>
          <el-button class="danger-button" size="mini" @click="openMaintainedTag">{{ $t('message.selectMaintainedTag')
          }}</el-button>
        </div>
      </div>

      <div class="tag-list" v-if="form.order_detail_tag.length">
        <div class="tag-card" v-for="(tag, tagIndex) in form.order_detail_tag" :key="tagIndex">
          <div class="tag-card-main">
            <div class="tag-card-head">
              <strong v-for="item in tagList" v-show="item.type === tag.type" :key="item.type">{{ item.remark
              }}</strong>
              <div class="tag-actions">
                <i class="el-icon-edit-outline" :title="$t('message.compile')" @click="editTag(tag, tagIndex)"></i>
                <i class="el-icon-printer" :title="$t('message.print')" @click="printTag(tag)"></i>
                <i class="el-icon-delete" :title="$t('message.delete')"
                  @click="form.order_detail_tag.splice(tagIndex, 1)"></i>
              </div>
            </div>
            <p>
              <span>{{ $t('message.labelNumber') }}</span>
              <em>{{ tag.no }}</em>
            </p>
            <p>
              <span>{{ $t('message.encodingFormat') }}</span>
              <em>{{ tag.code_type }}</em>
            </p>
            <p>
              <span>{{ $t('message.commodityManagementCode') }}</span>
              <em>{{ tag.goods_no }}</em>
            </p>
            <p v-for="n in 4" :key="n">
              <span>{{ $t('message.labelText') }}({{ n }})</span>
              <em>{{ tag['text_line_' + lineKey(n)] }}</em>
            </p>
          </div>
          <div class="tag-barcode">
            <svg :ref="'barcode-' + tagIndex"></svg>
            <p class="no">{{ tag.no }}</p>
            <p>{{ tag.text_line_one }}</p>
            <p>{{ tag.text_line_two }}</p>
            <p>{{ tag.text_line_three }}</p>
            <p>{{ tag.text_line_four }}</p>
          </div>
        </div>
      </div>
      <div class="empty-block" v-else>{{ $t('message.noTag') }}</div>
    </div>

    <!-- 辅料使用 -->
    <div class="plan-block">
      <div class="block-head">
        <div class="section-name">{{ $t('message.materialUsage') }}</div>
        <el-button class="danger-button" size="mini" @click="openBindMaterial">{{
          $t('message.bindingAuxiliaryMaterials')
        }}</el-button>
      </div>

      <div class="material-list" v-if="form.material.length">
        <div class="material-card" v-for="(item, index) in form.material" :key="item.material_id || index">
          <div class="material-img">
            <el-image v-if="item.main_image" :src="item.main_image" fit="cover" :preview-src-list="[item.main_image]" />
          </div>
          <div class="material-info">
            <div class="material-name" :title="item.name_trans" @click.stop="openMaterialDetail(item)">{{ item.name_trans }}</div>
            <p>{{ $t('message.inventoryQuantity') }}：{{ item.material_stock_num }}</p>
            <p>{{ $t('message.type') }}：{{ item.type_name }}</p>
            <div class="consume-row">
              <span>{{ $t('message.materialConsumption') }}：</span>
              <el-input v-model="item.consume" size="mini" class="consume-input" />
              <span>{{ $t('message.pointPerSet') }}</span>
            </div>
          </div>
          <i class="el-icon-delete delete-icon" @click="form.material.splice(index, 1)"></i>
        </div>
      </div>
      <div class="empty-block" v-else>{{ $t('message.noBoundMaterial') }}</div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('message.cancel') }}</el-button>
      <el-button type="primary" class="primary" :loading="saving" @click="submit">{{ $t('message.save') }}</el-button>
    </div>

    <order-option-dialog ref="orderOptionDialog" @confirm="onOptionConfirm" />
    <history-tag-dialog ref="historyTagDialog" @confirm="onTagConfirm" />
    <maintained-tag-dialog ref="maintainedTagDialog" @confirm="onTagConfirm" />
    <tag-edit-dialog ref="tagEditDialog" :tag-list="tagList" @save="onTagSave" />
    <bind-material-dialog ref="bindMaterialDialog" @confirm="onMaterialConfirm" />
    <!-- 商品属性编辑（参考订单详情 editAttribute） -->
    <el-dialog :title="$t('message.propertyEditForm')" :close-on-click-modal="false"
      :visible.sync="attributeDialogVisible" width="900px" center append-to-body>
      <edit-attribute ref="detailRef" @save="receiveAttributeEdit" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="attributeDialogVisible = false">{{ $t('message.cancel') }}</el-button>
        <el-button type="primary" @click="saveAttribute">{{ $t('message.save') }}</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
/**
 * 新增、编辑下单方案弹框（width: 1650px）
 *
 * 功能分区：
 * 1. 方案基础信息（名称、是否默认下单）
 * 2. 下单链接组套：1 个主商品 + 最多 3 个同捆物（children）
 * 3. 标签信息：历史标签 / 新建 / 已维护标签
 * 4. 辅料绑定：选择辅料并填写消耗
 *
 * 保存接口：productManagementApi.orderPlanStore / orderPlanUpdate
 * 新增勾选或编辑默认状态时，再调 orderPlanSetDefault
 *
 * 子弹框按组件拆分：
 * - OrderOptionDialog 附加服务
 * - HistoryTagDialog 历史标签
 * - MaintainedTagDialog 已维护标签
 * - BindMaterialDialog 绑定辅料
 * - editAttribute 商品属性编辑（参考订单详情）
 */
import JsBarcode from 'jsbarcode'
import EditAttribute from '@/components/common/editAttribute.vue'
import OrderOptionDialog from './orderOptionDialog'
import HistoryTagDialog from './historyTagDialog'
import MaintainedTagDialog from './maintainedTagDialog'
import TagEditDialog from './tagEditDialog'
import BindMaterialDialog from './bindMaterialDialog'

// 组套子商品（同捆物）数量上限：业务约定最多绑定 3 个
const CHILD_MAX = 3

export default {
  name: 'CreatePlanDialog',
  components: {
    EditAttribute,
    OrderOptionDialog,
    HistoryTagDialog,
    MaintainedTagDialog,
    TagEditDialog,
    BindMaterialDialog
  },
  data() {
    return {
      dialogVisible: false, // 主弹框显示状态
      editId: '', // 编辑方案 ID；为空时表示新增
      saving: false, // 保存按钮 loading，防止重复提交
      currentDetail: {}, // 当前商品详情
      form: this.createEmptyForm(), // 创建方案表单数据
      // 当前正在编辑属性的目标：main | childIndex(number)
      attributeEditTarget: 'main',
      // 当前编辑附加服务的商品：main | childIndex(number)
      optionEditTarget: 'main',
      attributeDialogVisible: false,
      // 当前属性弹框对应的 SKU 库存，用于反查价格和规格 ID
      goodsInventory: [],
      // 标签仓库类型枚举
      tagList: []
    }
  },
  computed: {
    dialogTitle() {
      return this.editId ? this.$t('message.editPlan') : this.$t('message.createPlan')
    },
    // 主商品已勾选的附加服务
    checkedOptions() {
      return this.form.option.filter(item => item.checked)
    }
  },
  methods: {
    /**
     * 标签文本行字段序号映射：1 -> one, 2 -> two ...
     * 用于动态绑定 text_line_one ~ text_line_four
     */
    lineKey(n) {
      return ['one', 'two', 'three', 'four'][n - 1]
    },
    /**
     * 初始化空表单
     * 主商品字段扁平挂在 form 上；同捆物挂在 children；标签/辅料/文件为数组
     */
    createEmptyForm() {
      return {
        name: '', // 方案名称 data[name]
        is_default: false, // 是否创建后设为默认方案
        link: '', // 主商品链接
        from_platform: '', // 来源平台，如 1688
        goods_id: '',
        goods_title: '',
        price: '',
        num: '',
        pic: '',
        detail: [], // 规格属性 [{ key, value }]
        sku_id: '',
        spec_id: '',
        shop_id: '',
        shop_name: '',
        mi_id: '',
        option: [], // 已选附加服务
        client_remark: '', // 客户备注
        order_detail_tag: [], // 标签列表
        material: [], // 辅料列表
        files: [], // 商品文件
        children: [], // 同捆物，最多 CHILD_MAX 条
        // 属性编辑依赖：goodsParticulars 完整响应缓存
        particularsRes: null,
        goodsInventory: []
      }
    },
    // 初始化一条空同捆物（组套子商品）
    createEmptyChild() {
      return {
        name: '',
        link: '',
        from_platform: '',
        goods_id: '',
        goods_title: '',
        price: '',
        num: '',
        pic: '',
        detail: [],
        sku_id: '',
        spec_id: '',
        shop_id: '',
        shop_name: '',
        mi_id: '',
        option: [],
        client_remark: '',
        particularsRes: null,
        goodsInventory: []
      }
    },
    /**
     * 外部打开弹框入口（列表页 openCreatePlan 调用）
     * @param {Object} detail 当前商品详情
     */
    open(detail) {
      this.currentDetail = detail
      this.resetForm()
      this.dialogVisible = true
      this.orderDetailTagList()
    },
    /**
     * 编辑方案：将接口数据合并到完整表单结构后再赋值。
     * Vue 2 无法监听已观测对象后续直接新增的字段，必须让主商品和同捆物字段在赋值时一次性存在。
     */
    edit(detail, plan) {
      this.currentDetail = detail
      this.resetForm()
      this.editId = plan.id
      const planData = JSON.parse(JSON.stringify(plan))
      const children = (planData.client_product_order_plan_child || []).map(child => ({
        ...this.createEmptyChild(),
        ...child,
        detail: child.detail || [],
        option: this.normalizeOptionList(child.option),
        goodsInventory: child.goodsInventory || []
      }))
      const material = (planData.material || []).map(item => ({
        material_id: item.material_id,
        consume: item.consume,
        name_trans: item.material_detail.name_trans,
        main_image: item.material_detail.main_image,
        material_stock_num: item.material_detail.material_stock_num,
        type_name: item.material_detail.type.name
      }))
      this.form = {
        ...this.createEmptyForm(),
        ...planData,
        is_default: planData.is_default == 1,
        detail: planData.detail || [],
        option: this.normalizeOptionList(planData.option),
        order_detail_tag: planData.order_detail_tag || [],
        files: planData.files || [],
        children,
        material,
        goodsInventory: planData.goodsInventory || []
      }
      this.dialogVisible = true
      this.orderDetailTagList()
    },
    // 编辑态接口返回的 option 即为已选服务，补齐 checked 供展示和弹框回显使用。
    normalizeOptionList(list) {
      return (list || []).map(item => ({
        ...item,
        checked: item.checked !== false
      }))
    },
    // 关闭或重新打开时重置表单与提交状态
    resetForm() {
      this.editId = ''
      this.form = this.createEmptyForm()
      this.saving = false
    },
    /**
     * 根据商品链接抓取商品基础信息
     * 流程：goodsUrlToGoodsId -> goodsParticulars
     * 回填标题/店铺/主图后，由调用方打开属性选择弹框
     * @param {String} url 商品链接
     * @param {Function} assignFn 回填回调
     */
    fetchProductByUrl(url, assignFn) {
      if (!url) return Promise.resolve()
      return this.$api.goodsUrlToGoodsId({ goods_url: url }).then(res => {
        const miId = res.data.mi_id
        const timestamp = Math.floor(Date.now() / 1000)
        const sign = 'wakanda forever!@9523`'
        return this.$api.orderApi.goodsParticulars({
          shop_type: res.data.from_platform,
          goods_id: res.data.goods_id,
          mi_id: miId,
          timestamp,
          sign: this.$md5(`${sign}${timestamp}${sign}`)
        }).then(detailRes => {
          const data = detailRes.data
          // 首次不自动选第一个规格，detail 置空，强制用户选择属性
          assignFn({
            goods_id: data.goodsId,
            goods_title: data.titleC,
            shop_id: data.shopId,
            shop_name: data.shopName,
            from_platform: data.fromPlatform,
            pic: data.images[0],
            mi_id: data.mi_id,
            detail: [],
            price: '',
            sku_id: '',
            spec_id: '',
            particularsRes: detailRes,
            goodsInventory: data.goodsInfo.goodsInventory
          })
        })
      })
    },
    // 主商品链接失焦：解析基础信息后打开属性选择
    fetchMainProduct() {
      this.fetchProductByUrl(this.form.link, data => {
        Object.assign(this.form, data)
        this.$forceUpdate()
        this.editMainAttribute()
      })
    },
    /**
     * 同捆物链接失焦：解析基础信息后打开属性选择
     * @param {Number} index 同捆物下标
     */
    fetchChildProduct(index) {
      const child = this.form.children[index]
      this.fetchProductByUrl(child.link, data => {
        Object.assign(child, data)
        child.name = data.goods_title
        this.$forceUpdate()
        this.editChildAttribute(index)
      })
    },
    /**
     * 打开主商品属性编辑
     * 依赖 particularsRes（解析链接后缓存）
     */
    editMainAttribute() {
      if (!this.form.particularsRes) {
        this.$message.warning(this.$t('message.pleaseEnterTheProductLink'))
        return
      }
      this.attributeEditTarget = 'main'
      this.goodsInventory = this.form.goodsInventory
      this.attributeDialogVisible = true
      this.$nextTick(() => {
        this.$refs.detailRef.goodsParticulars(JSON.parse(JSON.stringify(this.form.particularsRes)), {
          detail: this.form.detail,
          sorting: 1,
          from_platform: this.form.from_platform,
          type: 'detail'
        })
      })
    },
    /**
     * 打开同捆物属性编辑
     * @param {Number} index 同捆物下标
     */
    editChildAttribute(index) {
      const child = this.form.children[index]
      if (!child.particularsRes) {
        this.$message.warning(this.$t('message.pleaseEnterTheProductLink'))
        return
      }
      this.attributeEditTarget = index
      this.goodsInventory = child.goodsInventory
      this.attributeDialogVisible = true
      this.$nextTick(() => {
        this.$refs.detailRef.goodsParticulars(JSON.parse(JSON.stringify(child.particularsRes)), {
          detail: child.detail,
          sorting: index + 2,
          from_platform: child.from_platform,
          type: 'detail'
        })
      })
    },
    saveAttribute() {
      this.$refs.detailRef.save()
    },
    receiveAttributeEdit(data, pic) {
      const target = this.attributeEditTarget === 'main'
        ? this.form
        : this.form.children[this.attributeEditTarget]
      target.detail = data
      if (pic) target.pic = pic
      this.searchPrice(data)
      this.attributeDialogVisible = false
    },
    searchPrice(data) {
      const target = this.attributeEditTarget === 'main'
        ? this.form
        : this.form.children[this.attributeEditTarget]
      let str = ''
      data.forEach(item => {
        str += item.value + '㊖㊎'
      })
      str = str.substr(0, str.length - 2)
      for (let i = 0; i < this.goodsInventory.length; i++) {
        if (this.goodsInventory[i].keyC == str) {
          target.price = this.goodsInventory[i].valueC[0].price
          target.sku_id = this.goodsInventory[i].valueC[0].skuId
          target.spec_id = this.goodsInventory[i].valueC[0].specId
          target.num = 1
          break
        }
      }
      this.$forceUpdate()
    },
    /**
     * 使用最新下单链接
     * 接口 getLatestLink 返回 link 后走主商品解析流程
     */
    useLatestLink() {
      this.$api.productManagementApi.getLatestLink({
        user_id: this.currentDetail.user_id,
        sys_code: this.currentDetail.sys_code
      }).then(res => {
        const data = res.data
        if (data.link) {
          this.form.link = data.link
          this.fetchMainProduct()
        }
      })
    },
    /**
     * 添加组套同捆物
     * 业务约束：一个主商品下最多 CHILD_MAX 个子商品
     */
    addChild() {
      if (this.form.children.length >= CHILD_MAX) {
        this.$message.warning(this.$t('message.comboChildLimitTip'))
        return
      }
      this.form.children.push(this.createEmptyChild())
    },
    // 删除指定下标的同捆物
    removeChild(index) {
      this.form.children.splice(index, 1)
    },
    // 打开附加服务选择弹框
    openOptionDialog() {
      this.optionEditTarget = 'main'
      this.$refs.orderOptionDialog.open(this.checkedOptions, this.form, this.currentDetail)
    },
    openChildOptionDialog(index) {
      this.optionEditTarget = index
      this.$refs.orderOptionDialog.open(this.form.children[index].option.filter(item => item.checked), this.form.children[index], this.currentDetail)
    },
    // 附加服务确认回调
    onOptionConfirm(list) {
      if (this.optionEditTarget === 'main') {
        this.form.option = list
      } else {
        this.form.children[this.optionEditTarget].option = list
      }
    },
    // 打开新增标签弹框，保存后再追加到方案。
    addTag() {
      this.$refs.tagEditDialog.open()
    },
    // 编辑弹框使用标签副本，保存前不修改列表数据。
    editTag(tag, index) {
      this.$refs.tagEditDialog.edit(tag, index)
    },
    // 打开当前标签的打印预览。
    printTag(tag) {
      this.$refs.tagEditDialog.printTag(tag)
    },
    // 新增时追加，编辑时替换原标签。
    onTagSave(tag, index) {
      if (index === null) {
        this.form.order_detail_tag.push(tag)
      } else {
        this.$set(this.form.order_detail_tag, index, tag)
      }
      this.$nextTick(() => this.renderBarcodes())
    },
    orderDetailTagList() {
      this.$api.clienteleApi.orderDetailTagList({}).then(res => {
        this.tagList = res.data
      })
    },
    // 打开历史标签弹框
    openHistoryTag() {
      this.$refs.historyTagDialog.open(this.currentDetail.sys_code, this.currentDetail.user_id)
    },
    // 打开已维护标签弹框
    openMaintainedTag() {
      this.$refs.maintainedTagDialog.open(this.currentDetail.client_product_tag)
    },
    // 历史标签 / 已维护标签选择后追加到表单
    onTagConfirm(tag) {
      this.form.order_detail_tag.push(tag)
      this.$nextTick(() => this.renderBarcodes())
    },
    /**
     * 根据标签番号和编码格式生成条码预览
     * 番号为空或格式非法时跳过
     */
    renderBarcodes() {
      this.form.order_detail_tag.forEach((tag, index) => {
        const refs = this.$refs['barcode-' + index]
        // v-for 中 ref 可能是数组
        const el = Array.isArray(refs) ? refs[0] : refs
        if (!el || !tag.no) return
        try {
          JsBarcode(el, tag.no, {
            format: tag.code_type === 'EN13' ? 'EAN13' : tag.code_type === 'EN8' ? 'EAN8' : tag.code_type,
            displayValue: false,
            height: 50,
            width: 1.2,
            margin: 0
          })
        } catch (e) {
          // 番号含非法字符时 JsBarcode 会报错，忽略即可
        }
      })
    },
    // 打开绑定辅料弹框
    openBindMaterial() {
      this.$refs.bindMaterialDialog.open(this.currentDetail.user_id)
    },
    // 点击辅料名称新开辅料详情
    openMaterialDetail(item) {
      const id = item.material_id || item.id
      if (!id) return
      const route = this.$router.resolve({
        path: '/materialDetail',
        query: {
          id,
          user_id: (this.currentDetail && this.currentDetail.user_id) || item.user_id || ''
        }
      })
      window.open(route.href, '_blank')
    },
    /**
     * 辅料确认回调：按 material_id 去重后追加
     * @param {Array} list 选中的辅料
     */
    onMaterialConfirm(list) {
      list.forEach(item => {
        const exists = this.form.material.some(material => material.material_id === item.material_id)
        if (!exists) this.form.material.push(item)
      })
    },
    /**
     * 组装 orderPlanStore 请求体
     * 顶层：user_id、sys_code
     * data：主商品 + option/tag/material/files/children
     */
    buildPayload() {
      return {
        user_id: this.currentDetail.user_id,
        sys_code: this.currentDetail.sys_code,
        data: {
          name: this.form.name,
          link: this.form.link,
          from_platform: this.form.from_platform,
          goods_id: this.form.goods_id,
          goods_title: this.form.goods_title,
          price: this.form.price,
          num: this.form.num,
          pic: this.form.pic,
          detail: this.form.detail,
          sku_id: this.form.sku_id,
          spec_id: this.form.spec_id,
          shop_id: this.form.shop_id,
          shop_name: this.form.shop_name,
          option: this.checkedOptions.map(item => ({
            id: item.id,
            name: item.name,
            price: item.price,
            num: item.num,
            checked: true
          })),
          client_remark: this.form.client_remark,
          order_detail_tag: this.form.order_detail_tag.map(item => ({
            type: item.type,
            no: item.no,
            goods_no: item.goods_no,
            code_type: item.code_type,
            text_line_one: item.text_line_one,
            text_line_two: item.text_line_two,
            text_line_three: item.text_line_three,
            text_line_four: item.text_line_four
          })),
          // 提交仅保留接口约定字段
          material: this.form.material.map(item => ({
            material_id: item.material_id,
            consume: item.consume
          })),
          files: this.form.files,
          children: this.form.children.map(item => ({
            id: item.id,
            name: item.name,
            link: item.link,
            from_platform: item.from_platform,
            goods_id: item.goods_id,
            goods_title: item.goods_title,
            price: item.price,
            num: item.num,
            pic: item.pic,
            detail: item.detail,
            sku_id: item.sku_id,
            spec_id: item.spec_id,
            shop_id: item.shop_id,
            shop_name: item.shop_name,
            option: item.option.filter(option => option.checked).map(option => ({
              id: option.id,
              name: option.name,
              price: option.price,
              num: option.num,
              checked: true
            })),
            client_remark: item.client_remark
          }))
        }
      }
    },
    /**
     * 保存下单方案
     * 1. 校验方案名称、主商品链接
     * 2. 新增调用 orderPlanStore，编辑调用 orderPlanUpdate
     * 3. 新增勾选或编辑默认状态时，再调 orderPlanSetDefault
     * 4. 关闭弹框并通知父组件刷新列表
     */
    submit() {
      if (!this.form.name) {
        this.$message.error(this.$t('message.pleaseEnterPlanName'))
        return
      }
      if (!this.form.link) {
        this.$message.error(this.$t('message.pleaseEnterTheProductLink'))
        return
      }
      if (!this.form.detail || !this.form.detail.length) {
        this.$message.error(this.$t('message.pleaseSelectMainProductAttribute'))
        return
      }
      this.saving = true
      const payload = this.buildPayload()
      const request = this.editId
        ? this.$api.productManagementApi.orderPlanUpdate({ ...payload, id: this.editId })
        : this.$api.productManagementApi.orderPlanStore(payload)
      request.then(res => {
        this.$message.success(res.msg || this.$t('message.saveSuccess'))
        const planId = this.editId || (res.data && (res.data.id || res.data.plan_id))
        if (planId && (this.editId || this.form.is_default)) {
          return this.$api.productManagementApi.orderPlanSetDefault({
            user_id: this.currentDetail.user_id,
            sys_code: this.currentDetail.sys_code,
            id: planId,
            is_default: this.form.is_default ? 1 : 0
          })
        }
      }).then(() => {
        this.dialogVisible = false
        this.$emit('success')
      }).finally(() => {
        this.saving = false
      })
    }
  },
  watch: {
    // 标签番号/内容变化时重绘条码预览
    'form.order_detail_tag': {
      deep: true,
      handler() {
        this.$nextTick(() => this.renderBarcodes())
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.plan-base {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  font-size: 14px;

  .plan-base-item {
    display: flex;
    align-items: center;
    margin-right: 40px;
  }

  .label {
    flex: 0 0 auto;
    margin-right: 8px;
    color: #333333;
    white-space: nowrap;
  }

  .el-input {
    width: 360px;
  }
}

.plan-block {
  margin-bottom: 18px;
  padding: 16px;
  border: 1px solid #E5E5E5;
  border-radius: 6px;
  background: #FFFFFF;
}

.block-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}

.section-name {
  height: 38px;
  padding: 0 18px;
  font-size: 18px;
  font-weight: bold;
  line-height: 38px;
  background: #F6F6F6;
  border-radius: 2px;
}

.block-actions {
  display: flex;
  gap: 8px;
}

.danger-button,
.success-button,
.warn-button {
  min-width: 64px;
  height: 32px;
  padding: 0 14px;
  color: #FFFFFF;
  font-size: 14px;
  border-radius: 4px;
}

.danger-button,
.danger-button:hover,
.danger-button:focus {
  color: #FFFFFF;
  background: #B4272D;
  border-color: #B4272D;
}

.success-button,
.success-button:hover,
.success-button:focus {
  color: #FFFFFF;
  background: #15AD3C;
  border-color: #15AD3C;
}

.warn-button,
.warn-button:hover,
.warn-button:focus {
  color: #FFFFFF;
  background: #E6A23C;
  border-color: #E6A23C;
}

.link-table {
  width: 100%;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  overflow-x: auto;
}

.link-head,
.link-row {
  display: grid;
  grid-template-columns: minmax(220px, 2fr) minmax(220px, 1.6fr) minmax(140px, 1.2fr) 100px 90px minmax(120px, 1.1fr) minmax(140px, 1.2fr);
  min-width: 1180px;
  margin: 0;
  padding: 0;
}

.link-head {
  background: #F8F8F8;

  >div {
    padding: 12px 10px;
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    border-right: 1px solid #E5E5E5;
    box-sizing: border-box;

    &:last-child {
      border-right: 0;
    }
  }
}

.combo-group {
  margin: 8px;
  border: 1px solid #F0C78A;
  border-radius: 4px;
  background: #FFF7E8;
  overflow: hidden;
}

.link-row {
  >div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-width: 0;
    padding: 12px 10px;
    font-size: 14px;
    border-right: 1px solid #F0C78A;
    box-sizing: border-box;

    &:last-child {
      border-right: 0;
    }
  }

  &+.link-row {
    border-top: 1px solid #F0C78A;
  }

  p {
    margin: 0 0 4px;
    line-height: 22px;
  }

  p span {
    display: inline-block;
    min-width: 42px;
    margin-right: 6px;
    color: #666666;
  }
}

.link-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.main-tag,
.child-tag {
  display: inline-block;
  padding: 2px 8px;
  color: #FFFFFF;
  background: #E6A23C;
  border-radius: 2px;
  font-size: 12px;
}

.latest-link {
  color: #B4272D !important;
  font-size: 14px;
}

.delete-text {
  color: #B4272D !important;
  margin-top: 8px;
}

.link-tip {
  margin-top: 8px !important;
  color: #B4272D;
  font-size: 12px;
  line-height: 18px !important;
}

.child-remark {
  align-items: stretch;

  .delete-text {
    align-self: flex-start;
  }
}

.product-info {
  display: flex;
  align-items: flex-start;
  min-width: 0;
}

.product-img {
  flex: 0 0 100px;
  width: 100px;
  height: 100px;
  margin-right: 10px;
  border-radius: 3px;
  background: #D8D8D8;
  overflow: hidden;
}

.product-text {
  flex: 1;
  min-width: 0;
}

.goods-title {
  display: -webkit-box;
  margin-bottom: 6px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  line-height: 20px !important;
  max-height: 60px;
  cursor: default;
}

.price-text {
  font-size: 14px;
  font-weight: bold;
  color: #333333;
  line-height: 32px;
}

.attr-box,
.option-box {
  min-height: 88px;
  padding: 8px;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  background: #FFFFFF;
  cursor: pointer;
  box-sizing: border-box;
}

.option-empty {
  color: #999999;
}

.tag-list,
.material-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.tag-card {
  display: flex;
  align-items: center;
  width: 620px;
}

.tag-card-main {
  flex: 0 0 330px;
  padding: 14px;
  font-size: 14px;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  box-sizing: border-box;

  .tag-card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 24px;
    margin-bottom: 10px;
  }

  .tag-actions {
    display: flex;
    gap: 12px;

    i {
      color: #315EDE;
      font-size: 17px;
      cursor: pointer;
    }

    .el-icon-delete {
      color: #E05A61;
    }
  }

  p {
    display: flex;
    align-items: center;
    margin: 0 0 6px;
    line-height: 22px;
  }

  span {
    flex: 0 0 112px;
    margin-right: 8px;
    color: #666666;
  }

  em {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    color: #333333;
    font-style: normal;
    text-align: right;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.tag-barcode {
  width: 175px;
  margin-left: 24px;
  text-align: center;
  font-size: 12px;
  color: #333333;

  .no {
    text-align: center;
  }

  p {
    text-align: left;
    margin: 2px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.delete-icon {
  position: absolute;
  top: 10px;
  right: 10px;
  color: #999999;
  cursor: pointer;

  &:hover {
    color: #B4272D;
  }
}

.material-card {
  position: relative;
  display: flex;
  width: 280px;
  min-height: 110px;
  padding: 12px;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  background: #FFFFFF;
  box-sizing: border-box;
}

.material-img {
  flex: 0 0 66px;
  width: 66px;
  height: 66px;
  margin-right: 10px;
  overflow: hidden;
  background: #D8D8D8;
  border-radius: 3px;

  .el-image {
    width: 100%;
    height: 100%;
  }
}

.material-info {
  flex: 1;
  min-width: 0;
  font-size: 14px;

  p {
    margin: 0 0 4px;
    color: #666666;
  }
}

.material-name {
  margin-bottom: 6px;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    color: #B4272D;
  }
}

.consume-row {
  display: flex;
  align-items: center;
  margin-top: 6px;
}

.consume-input {
  width: 72px;
  margin: 0 6px;
}

.empty-block {
  padding: 24px 0;
  color: #999999;
  text-align: center;
}

.dialog-footer {
  text-align: center;

  .primary {
    background: #B4272D;
    border-color: #B4272D;
  }
}
</style>

<style lang="scss">
.create-plan-dialog {
  .el-dialog__body {
    max-height: calc(92vh - 140px);
    overflow: auto;
    padding-top: 12px;
  }
}
</style>
